module.exports = __webpack_public_path__ + "media/printed-materials/educators-01-poster-6dc3b5e0.jpg";